import React, { lazy, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons/faAngleDoubleRight'
import { StaticImage } from 'gatsby-plugin-image'

import { allCities, serviceCityGroupMapping } from '../utils/cities'
import { validateMobile, fetchPayload, submitPayload } from '../utils/helpers'
import './leadcapture.css'

const ReCAPTCHA = lazy(() => import('react-google-recaptcha'))

const medicalServices = Object.keys(serviceCityGroupMapping)

function LeadCapture({
  cta,
  heading,
  service,
  forRental,
  forEquipment,
  location: page,
}) {

  console.log("For Rental: ", forRental)
  console.log("For Equipment: ", forEquipment)
  const [formState, setFormState] = useState({
    name: '',
    mobilenumber: '',
    city: '',
    submitted: false,
    userService: '',
    rental: forRental,
    equipment: forEquipment,
  })

  const [showRecaptcha, setShowRecaptcha] = useState(false)

  const [formEvent, setFormEvent] = useState(null)

  const recaptchaInstance = useRef()

  useEffect(() => {
    const listener = () => {
      if (!showRecaptcha) {
        setShowRecaptcha(true)
      }
    };
    document.addEventListener('mousemove', listener);
    return () => {
      document.removeEventListener('mousemove', listener);
    };
  }, []);

  const resetState = () => {
    setFormState({
      ...formState,
      name: '',
      mobilenumber: '',
      city: '',
      submitted: false,
      userService: '',
    })
  }

  const handleChange = (event) => {
    const { target } = event
    const { name, value } = target

    if (name === 'mobilenumber' && value.length > 10) return

    const isRental = name === 'rental'
    if (isRental) {
      setFormState({
        ...formState,
        rental: isRental,
        userService: isRental ? 'Equipment  Rental' : 'Equipment Sales',
      })
      return
    }

    setFormState({ ...formState, [name]: value })
  }

  const verifyForm = () => {
    const { name: username, mobilenumber, city } = formState

    const isValid = validateMobile(mobilenumber)
    if (isValid === false) {
      // eslint-disable-next-line no-alert
      alert('Please enter valid 10 digit Mobile Number.')
      return false
    }

    if (username.length === 0) {
      // eslint-disable-next-line no-alert
      alert('Please provide your name')
      return false
    }

    if (city === '') {
      // eslint-disable-next-line no-alert
      alert('Please select the city where service is needed')
      return false
    }

    return true
  }

  const handleSubmit = (e, verifyKey) => {
    e.preventDefault()

    const { name: username, mobilenumber, city, userService } = formState

    const validForm = verifyForm()

    if (!validForm) return false

    setFormState({ ...formState, submitted: true })

    const payload = fetchPayload({
      username,
      mobilenumber,
      page,
      service: service || userService,
      city,
      verifyKey,
    })
    submitPayload(payload, () => {
      window.location.href = 'https://www.portea.com/thank-you'
    })
    return true
  }

  const verifyRecaptcha = (cresp) => {
    console.log('Received captcha response')
    handleSubmit(formEvent, cresp)
    setFormEvent(null)
    resetState()
  }

  const executeRecaptcha = (e) => {
    e.preventDefault()
    console.log('Prevented default')
    setFormEvent(e)
    if (verifyForm()) {
      console.log('Executing')
      recaptchaInstance.current.execute()
    }
  }

  const validCities = serviceCityGroupMapping[service] || allCities

  const {
    name,
    mobilenumber,
    city,
    submitted,
    userService,
    rental,
    equipment,
  } = formState

  return (
    <div className="formWrapper" onMouseEnter={() => !showRecaptcha && setShowRecaptcha(true)}>
      <div className="book-box-icon" />
      <div className="book-box">
        <div className="book-box-icon1">
          <div className="cover">
            <StaticImage
              src="../img/icons/icon_generic_book_appointment.png"
              alt="Booking"
            />
          </div>
        </div>
        <div className="book-head">{heading || 'Book Appointment'}</div>

        {!submitted && (
          <div className="form-content">
            <form id="booktest" role="form" autoComplete="on">
              <div className="field">
                <label htmlFor="name">Name</label>
                <div className="control">
                  <input
                    type="text"
                    name="name"
                    className="input"
                    id="name"
                    value={name}
                    onChange={handleChange}
                    placeholder="Please provide your name"
                  />
                </div>
              </div>

              <div className="field">
                <label htmlFor="mobilenumber">Mobile Number*</label>
                <div className="control">
                  <input
                    type="number"
                    className="input"
                    id="mobilenumber"
                    name="mobilenumber"
                    value={mobilenumber}
                    onChange={handleChange}
                    placeholder="To coordinate with you"
                  />
                </div>
              </div>
              {service == null && (
                <div className="field">
                  <label htmlFor="userService">Service*</label>
                  <div className="control">
                    <div className="select is-fullwidth">
                      <select
                        value={userService}
                        required
                        id="userService"
                        name="userService"
                        onChange={handleChange}
                      >
                        <option value="" disabled hidden>
                          Medical Service
                        </option>
                        {medicalServices.sort().map((s) => (
                          <option key={s}>{s}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              )}
              <div className="field">
                <label htmlFor="city">City*</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      value={city}
                      required
                      id="city"
                      name="city"
                      onChange={handleChange}
                    >
                      <option value="" disabled hidden>
                        Service Needed In?
                      </option>
                      {validCities.sort().map((c) => (
                        <option key={c}>{c}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              {equipment && (
                <div className="field">
                  <label htmlFor="city">Booking Type*</label>
                  <div className="control">
                    <label className="radio">
                      <input
                        type="radio"
                        name="rental"
                        checked={rental}
                        value="rental"
                        onChange={handleChange}
                      />
                      Rental
                    </label>
                    <label className="radio">
                      <input
                        type="radio"
                        name="rental"
                        checked={!rental}
                        value="purchase"
                        onChange={handleChange}
                      />
                      Purchase
                    </label>
                  </div>
                </div>
              )}
              <p className="small" style={{ marginBottom: 20 }}>
                <i>
                  *I authorize Portea representative to contact me. I understand
                  that this will override the DND status on my mobile number.
                </i>
              </p>
              <div className="field">
                <div className="control">
                  <button
                    type="button"
                    className="button is-medium is-fullwidth is-cta"
                    onClick={executeRecaptcha}
                  >
                    <span>{cta || 'Submit'}</span>
                    <FontAwesomeIcon
                      icon={faAngleDoubleRight}
                      color="white"
                      className="action-icon"
                    />
                  </button>
                </div>
              </div>
            </form>

            {showRecaptcha && <ReCAPTCHA
              ref={recaptchaInstance}
              sitekey="6Lfdg94jAAAAABNyjfX7uSJVmxfy_Jugb3CLAT7Q"
              size="invisible"
              onChange={verifyRecaptcha}
              isolated="true"
            /> }
          </div>
        )}

        {submitted && (
          <div
            className="card-content"
            style={{ border: '1px solid grey', borderRadius: 3, padding: 5 }}
          >
            Thanks! We will get in touch with you shortly to arrange for the
            appointment.
          </div>
        )}
      </div>
    </div>
  )
}

export default LeadCapture
